module.exports = __webpack_public_path__ + "assets/img/16.5137fedd.png";